import api from '@seller-hermes/utils/api';
import { PostReportBody } from './report.query.types';

export const report = (body: PostReportBody) => api.post(`/v1/report`, body);
